var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_12990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1219 18.7502C16.6053 19.5395 17.2343 20.1197 18.3466 20.1197C19.2811 20.1197 19.8781 19.6526 19.8781 19.0073C19.8781 18.234 19.2647 17.9601 18.2362 17.5102L17.6724 17.2683C16.0449 16.5749 14.9638 15.7064 14.9638 13.8702C14.9638 12.1787 16.2525 10.8911 18.2666 10.8911C19.7005 10.8911 20.7314 11.3902 21.4743 12.6968L19.7181 13.8244C19.3314 13.1311 18.9143 12.858 18.2666 12.858C17.6061 12.858 17.1874 13.277 17.1874 13.8244C17.1874 14.501 17.6065 14.7749 18.5741 15.194L19.1379 15.4355C21.0541 16.2572 22.136 17.0949 22.136 18.9784C22.136 21.0088 20.5409 22.1212 18.3988 22.1212C16.3044 22.1212 14.9512 21.1231 14.2891 19.8149L16.1219 18.7502ZM8.15502 18.9456C8.50931 19.5742 8.83159 20.1056 9.60645 20.1056C10.3474 20.1056 10.8148 19.8157 10.8148 18.6884V11.0199H13.0701V18.7189C13.0701 21.0542 11.7009 22.117 9.70245 22.117C7.89674 22.117 6.85102 21.1825 6.31921 20.057L8.15502 18.9456Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_12990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.0904266f7746c015b4a154ff9f1b6011.svg";
export { ForwardRef as ReactComponent };